import React from 'react';
import { AdviceFooter } from '@trp-individual-investor-adv-disc/adv-shared';
import FPSThemeWrapper from '../FPSThemeWrapper/FPSThemeWrapper';
import BlueBanner from '../BlueBanner/BlueBanner';
import { footerDisclaimer } from '../../utils/Content';
import './TransferWrapper.scss';

const TransferWrapper = ({children, confirm}) => {

    const headerText = !confirm ?
        'Transfer to Retirement Advisory Service' :
        'Your transfer to Retirement Advisory Service has been submitted!';

    const subHeaderText = !confirm ?
        'Receive professional management of new assets you contribute to your advisory accounts in the Service.' :
        ' '; // empty string needed to override default

    const DisclosureContent = () => <div className='footerDisclosuresWrapper'>
        <div className='footerDisclosuresContent'>
            <div>202307 - 2931001</div>
            <div>
                <strong>*Please note:</strong> {footerDisclaimer.averageCostNote}
                <br /><br />
                <strong>*Note Potential tax Implications:</strong> {footerDisclaimer.potentialTaxImplications}
                <br /><br />
                <strong>*Our Excessive Trading policy:</strong> {footerDisclaimer.excessiveTradingPolicy}
            </div>
        </div>
    </div>;


    return <div id="captureTransfer">
        <FPSThemeWrapper>
            <BlueBanner
                header={headerText}
                subheader={subHeaderText}
                showBannerButtons={false}
                showBreadcrumbs
                breadcrumbs={[
                    {'url': 'usis/my-accounts/dashboard', 'displayText': 'My Accounts'},
                    {'url': 'usis/transactions', 'displayText': 'Transactions'},
                    {'displayText': 'Retirement Advisory Service - Transfer'}
                ]}
            />
        </FPSThemeWrapper>
            {children}
            <div className='footerVerticalSpacer' />
        <AdviceFooter
            copyright='RAS'
            disclosures={confirm ? null : <DisclosureContent />}
        />
    </div>
}

export default TransferWrapper;
